// extracted by mini-css-extract-plugin
module.exports = {"container":"i_AP","circle":"i_AQ","animate":"i_AR","multi-coloured":"i_AS"};